export type CodePart = { text: string; color: string };

export const parseHtmlSnippet = (snippet: string): CodePart[] => {
  const regex = /(<\/?[\w-]+)|([\w-]+)=("|')([^"']+)("|')|>/g;

  const result: CodePart[] = [];
  let lastIndex = 0;

  let match;
  while ((match = regex.exec(snippet))) {
    const [fullMatch] = match;
    const index = match.index;

    if (index > lastIndex) {
      result.push({ text: snippet.slice(lastIndex, index), color: 'black' });
    }

    if (match[1]) {
      result.push({ text: match[1], color: 'green' });
    } else if (match[2]) {
      result.push({ text: `${match[2]}=`, color: 'pink' });
      result.push({ text: `"${match[4]}"`, color: 'blue' });
    } else if (fullMatch === '>') {
      result.push({ text: '>', color: 'green' });
    }

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < snippet.length) {
    result.push({ text: snippet.slice(lastIndex), color: 'black' });
  }

  return result;
};
